export default __webpack_public_path__ + "fbd67ba.png";